// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1ZCTt","content":"ManualTimeModal_content__3davd"};